import Vue from 'vue'
import Router from 'vue-router'


import App from '@/layouts/App'
import StepOne from '@/views/StepOne'
import StepTwo from '@/views/StepTwo'
import StepThree from '@/views/StepThree'
import StepFour from '@/views/StepFour'
import ExcelExport from '@/views/ExcelExport'
import Playground from '@/views/Playground'

Vue.use(Router)

export default new Router({
    linkActiveClass: 'active',
    routes: [
    {
        path: '/',
        component: App,
        children: [
            {
                path: '/',
                name: 'StepOne',
                component: StepOne
            },
            {
                path: '/StepTwo',
                name: 'StepTwo',
                component: StepTwo
            },
            {
                path: '/StepThree',
                name: 'StepThree',
                component: StepThree
            },
            {
                path: '/StepFour',
                name: 'StepFour',
                component: StepFour
            },
            {
                path: '/ExcelExport',
                name: 'ExcelExport',
                component: ExcelExport
            },
            {
                path: '/Playground',
                name: 'Playground',
                component: Playground
            },
            {
                path: '/search/:productId',
                name: 'search',
                component: StepOne
            }
        ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/services/router.js